<template>
  <div v-if="list.length">
    <Table
      :border="opts.border"
      :columns="columns"
      :data="list"
      :disabledHover="opts.disabledHover"
      :highlightRow="opts.highlightRow"
      :loading="opts.loading"
      :size="opts.size"
      :stripe="opts.stripe"
      @on-select="selected"
      @on-select-all="selectedAll"
      @on-selection-change="selectedChange"
      ref="currentTable"
      class="business-table"
    ></Table>
    <Page :page-size="page.size" :total="page.total" :show-elevator="page.showElevator" @on-change="changePage" class="table-page-right" v-if="opts.page !== false" :model-value="page.page" />
  </div>
  <div class="height-400 flex-center" v-else>
    <div>
      <img alt="" src="@Assets/images/placeholder_Empty.png" />
      <div class="text-center mt16 c-666 line-height-22">暂无数据</div>
    </div>
  </div>
</template>

<script>
const defaultOptions = {
  loading: false,
  disabledHover: false,
  highlightRow: false,
  page: true,
  size: 'default',
  stripe: false,
  border: false
}
const pageOptions = {
  page: 1,
  size: 10
}
export default {
  emits: ['on-select-all', 'on-selection-change', 'on-select'],
  name: 'BusinessTable',
  props: ['columns', 'options', 'query', 'data', 'showElevator'],
  data() {
    // todo size 外部设置 没有用
    return {
      opts: {},
      list: [],
      page: {
        total: 0,
        showElevator: this.showElevator,
        ...pageOptions
      }
    }
  },
  created() {
    this.opts = {
      ...defaultOptions,
      ...this.options
    }
    this.initPageSize()
    if (this.data) {
      this.list = this.data
      this.page.total = this.list.length
      this.page.page = 1
    } else {
      this.refresh()
    }
  },
  methods: {
    initPageSize() {
      Object.keys(pageOptions).forEach(key => {
        if (this.query && this.query.params && this.query.params[key]) {
          this.page[key] = this.query.params[key]
        } else {
          this.page[key] = pageOptions[key] || this.page[key]
        }
      })
    },
    selectedAll(data) {
      this.$emit('on-select-all', data)
    },
    selectedChange(data) {
      this.$emit('on-selection-change', data)
    },
    selected(data) {
      this.$emit('on-select', data)
    },
    refresh() {
      // this.page = {...this.page, ...pageOptions}
      this.initPageSize()

      // 重置page
      if (this.query && this.query.params) {
        this.query.params.page = 1
      }
      this.page.page = 1
      this._queryData()
    },
    update() {
      this._queryData()
    },
    changePage(page) {
      this.page.page = page
      if (this.opts.page && this.query.params && this.query.params.page) {
        this.query.params.page = page
      }
      this._queryData()
    },
    _queryData() {
      let { url = '', params = {} } = this.query || {}
      const _this = this
      if (this.opts.page !== false) {
        params = {
          page: this.page.page,
          size: this.page.size,
          ...params
        }
      }
      if (!url) return
      this.$ajax
        .get(url, {
          params
        })
        .then(res => {
          if (_this.opts.page === false) {
            _this.page.total = res.length || 0
            _this.list = res
          } else {
            _this.page.total = res.total
            _this.list = res.data || []
          }
        })
        .catch(() => {
          _this.page.total = 0
          _this.page.page = 1
        })
    }
  }
}
</script>

<style lang="less">
.table-page-right {
  text-align: right;
  margin-top: 24px;
}

.business-table.ivu-table-wrapper {
  .ivu-table {
    color: #333333;
  }

  .ivu-table .ivu-table-header thead tr th,
  .ivu-table .ivu-table-fixed-header thead tr th {
    height: 56px;
    color: #8d9099;
  }

  .ivu-table .ivu-table-header thead tr th {
    background-color: rgba(239, 239, 245, 0.3);
  }

  .ivu-table .ivu-table-fixed-header thead tr th {
    background-color: #f8fafb;
  }

  .ivu-table td {
    height: 68px;
    border-bottom: 1px solid rgba(204, 204, 204, 0.3);
  }

  .ivu-table-cell {
    padding-left: 12px;
    padding-right: 12px;
  }
}
</style>
